import { makeVar } from "@apollo/client";
import { DEFAULT_WHITELABEL_VALID_JR_STEPS } from "../../constants";
import { WhiteLaelStepEnum } from "../../types";

export const whiteLabelStep = makeVar(WhiteLaelStepEnum.ProjectSettings);
export const isDisabledWhiteLabelProjectTabs = makeVar(true);
export const whiteLabelJRStep = makeVar(0);
export const whiteLabelJRActive = makeVar(false);
export const whiteLabelJRStartModal = makeVar(false);
export const whiteLabelValidJRSteps = makeVar(
  DEFAULT_WHITELABEL_VALID_JR_STEPS
);
